export default __webpack_public_path__ + "static/media/6B5_E-4735.c5a7e7f8.png";